import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Img, List, Text } from "components";
import Footer from "components/Footer";
import { useTranslation } from "react-i18next";
import FeatureCards from "components/WhyChooseToUs";
import { useAppFont } from "utils/helper/useAppFont";

const DesignMyOwnCake = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [current, setCurrent] = useState(0);
  const {interClass, interFamily, headingClass, headingFamily} = useAppFont();

  const images = [
    { src: "images/cake1.png", alt: "Pink heart-shaped cake with white cream decoration" },
    { src: "images/cake2.png", alt: "Pink heart-shaped cake with colorful sprinkles" },
    { src: "images/cake3.png", alt: "Round vanilla cake with cream decoration" },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="bg-white-A700 flex flex-col items-center justify-start mx-auto w-full">
        <div className="flex flex-col items-center justify-start w-full">
          <div className={`${headingClass} h-[465px] sm:h-auto md:px-5 relative w-full bg-gray-50_02 relative overflow-hidden`}>
            
            <div className="relative w-full bg-[#fff7f8] py-20 md:py-16 sm:py-10">
              <div className="flex flex-col gap-6 items-center justify-center w-[70%] md:w-[85%] sm:w-full sm:px-5 mx-auto text-center">
                
                <div className="flex flex-wrap items-center justify-center gap-3 md:gap-2 sm:gap-1">
                  <span className={`${headingClass} font-bold text-[44px] md:text-[38px] sm:text-[26px] text-[#771237] whitespace-nowrap`}>
                    Over 600+
                  </span>
                  
                  <img 
                    src="/images/cust1.png" 
                    alt="cake" 
                    className="w-[48px] h-[48px] md:w-[42px] md:h-[42px] sm:w-[32px] sm:h-[32px] object-contain bg-[#F1F4F6] rounded-full mr-[-20px] sm:mr-[-12px]"
                  />
                  <img 
                    src="/images/cust2.png" 
                    alt="cupcake" 
                    className="w-[48px] h-[48px] md:w-[42px] md:h-[42px] sm:w-[32px] sm:h-[32px] object-contain bg-[#F1F4F6] rounded-full mr-[-20px] sm:mr-[-12px]"
                  />
                  <img 
                    src="/images/cust3.png" 
                    alt="cake slice" 
                    className="w-[48px] h-[48px] md:w-[42px] md:h-[42px] sm:w-[32px] sm:h-[32px] object-contain bg-[#F1F4F6] rounded-full mr-[-20px] sm:mr-[-12px]"
                  />
                  <img 
                    src="/images/cust4.png" 
                    alt="cake slice" 
                    className="w-[48px] h-[48px] md:w-[42px] md:h-[42px] sm:w-[32px] sm:h-[32px] object-contain bg-[#F1F4F6] rounded-full"
                  />
                  
                  <span className={`${headingClass} font-bold text-[44px] md:text-[38px] sm:text-[26px] text-[#d08a9b]`}>
                    Cakes
                  </span>
                  <span className={`${headingClass} font-bold text-[44px] md:text-[38px] sm:text-[26px] text-[#771237]`}>Turned Into </span>
                  <span className={`${headingClass} font-bold text-[44px] md:text-[38px] sm:text-[26px] text-[#d08a9b]`}>Reality...</span>
                </div>

                <Text
                  className={`text-[20px] text-[#8D4660] max-w-2xl leading-[28px] mt-2 ${interClass} font-normal text-center sm:text-[12px] sm:text-left sm:leading-[22px] sm:mt-1 sm:text-start`}
                  style={{ 
                    color: 'var(--Main-Color-SubText, #8D4660)',
                    fontFamily: interFamily,
                    fontSize: '20px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: '28px'
                  }}
                >
                  <span>Design your dream cake with our easy customizer.</span>
                  <span>Premium ingredients, expert craftsmanship, delivered fresh to your door.</span>
                </Text>

                <Button
                  onClick={() => navigate("/design-my-custom-cake")}
                  hover={true}
                  hoverclass="bg-[#5a1128]"
                  className="mt-4 sm:mt-2 bg-[#771237] hover:bg-[#5a1128] transition-all duration-300  
                            text-white px-12 sm:px-8 py-3.5 sm:py-3 rounded-full text-[16px] sm:text-[14px] font-nunitomedium 
                            cursor-pointer relative sm:w-full"
                  style={{
                    boxShadow: '0px 4px 20px 0px rgba(119, 18, 55, 0.35), 0px 8px 40px 0px rgba(221, 136, 170, 0.25)',
                    border: 'none'
                  }}
                >
                  <span className={`${headingClass} leading-[24px] text-[16px] sm:text-[14px] text-[#FFFFFF]`}>{t("customizedCakes")}</span>
                </Button>

              </div>
            </div>
            <div
              className="absolute bg-cover bg-no-repeat flex flex-col h-[213px] items-start justify-end left-[28%] p-[13px] top-[40px] w-[194px]"
            ></div>
          </div>
          <div className="max-w-[1100px] w-full mx-auto md:max-w-full md:px-4 overflow-hidden">

            <div className="flex flex-row sm:flex-col mt-20 sm:mt-10 w-full sm:gap-3 sm:px-4">
              <h2 className="text-4xl md:text-[38px] sm:text-[26px] font-bold text-[#771237] text-start mb-4 w-[40%] sm:w-full">
                How It Works
              </h2>
              <p className="text-base text-center sm:text-left text-[#8D4660] max-w-[600px] mx-auto sm:mx-0 sm:max-w-full leading-relaxed w-[50%] sm:w-full sm:text-[14px]">
                Create your perfect custom cake in three simple steps. From <br className="sm:hidden"/>design to delivery, we make it easy and delicious.
              </p>
            </div>

            <div className="mt-16 sm:mt-8">
              <div className="max-w-5xl mx-auto px-4 p-10 sm:p-4 sm:px-2">
                <div className="flex flex-row md:grid-cols-2 gap-12 mb-20 sm:mb-10">
                  <div className="flex flex-row sm:flex-col-reverse justify-between w-full sm:gap-4">
                    
                    <div className="w-[70%] sm:w-full">
                      <h3 className={`text-2xl sm:text-[18px] font-semibold text-gray-900 mb-3 ${headingClass} text-[#771237]`}>
                        Design Your Cake
                      </h3>
                      <p className="text-sm text-[#8D4660] leading-relaxed max-w-auto">
                        Choose your size, shape, flavors, and decorations with our easy-to-use customizer.
                      </p>
                      <p className="text-sm text-[#8D4660] leading-relaxed max-w-auto"> Make it uniquely yours with colors, toppings, and personal messages.</p>
                    </div>
                    <div className="w-[30%] sm:w-full sm:flex sm:justify-center">
                      <img 
                        src="/images/customize1.png" 
                        alt="Design Your Cake" 
                        className="w-48 h-48 sm:w-full sm:h-full object-cover"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex justify-between flex-row sm:flex-col gap-2 sm:gap-10 mb-20 sm:mb-10">
                  <div className="flex flex-col items-center text-center sm:flex-col sm:items-center sm:text-left sm:gap-5">
                    <h3 className="text-2xl sm:text-[20px] font-semibold text-[#771237] mb-3 sm:mb-0">
                      Review & Confirm
                    </h3>
                    <div className="mb-6 sm:mb-0 sm:flex-shrink-0">
                      <img 
                        src="/images/reviewImg.png" 
                        alt="Review & Confirm" 
                        className="w-48 h-48 sm:w-auto sm:h-auto object-cover"
                      />
                    </div>
                  </div>
                    <div className="flex flex-col items-center text-center sm:flex-col sm:items-center sm:text-left sm:gap-5">
                      <h3 className="text-2xl sm:text-[20px] font-semibold text-[#771237] mb-3 sm:mb-0">
                      We Bake & Deliver
                    </h3>
                    <div className="mb-6 sm:mb-0 sm:flex-shrink-0">
                      <img 
                        src="/images/bakeAndDeliver.png" 
                        alt="We Bake & Deliver" 
                        className="w-48 h-48 sm:w-auto sm:h-auto object-cover"
                      />
                    </div>
                    
                  </div>

                  <div className="flex flex-col items-center text-center sm:flex-col sm:items-center sm:text-left sm:gap-5">
                    <h3 className="text-2xl sm:text-[20px] font-semibold text-[#771237] mb-3 sm:mb-0">
                      Celebrate!
                    </h3>
                    <div className="mb-6 sm:mb-0 sm:flex-shrink-0">
                      <img 
                        src="/images/celebrate.png" 
                        alt="Celebrate!" 
                        className="w-48 h-48 sm:w-auto sm:h-auto object-cover"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section
            id="section-7"
            className="relative w-full mx-auto md:max-w-full md:px-4 bg-[#FEFBFC] overflow-hidden"
          >
            <div className="max-w-[1100px] w-full mx-auto py-24 sm:py-10 flex flex-col items-center justify-between md:gap-8 sm:flex-col">
              <div className="flex flex-row font-nunitobold sm:gap-5 items-start justify-center relative w-full max-w-[1080px]">
                <div className="w-full flex flex-col items-start text-start mb-8 sm:mb-4 sm:px-4">
                  <div
                    className="flex items-start gap-2 bg-[#FFD6DE] text-[#9B1C3A]
                              px-5 py-2 rounded-full text-sm font-medium mb-6 sm:mb-4"
                    style={{ fontFamily: interFamily }}
                  >
                    <span className="w-2 h-2 bg-[#E11D48] rounded-full text-[14px]"></span>
                    Yummy · easy-to-use customizer
                  </div>

                  <div className="flex flex-row sm:flex-col w-full sm:gap-4">
                    <div className="w-[50%] sm:w-full flex flex-col items-start justify-start">
                      <h2
                        className="text-[32px] leading-[48px] max-w-[760px]
                                  sm:text-[28px] sm:leading-[54px]
                                  xs:text-2xl"
                        style={{
                          fontFamily: headingFamily,
                          color: "#6B1433",
                          fontWeight: 500,
                        }}
                      >
                        Easiest Way to Order Your Perfect Cake
                      </h2>
                    </div>
                    <div className="w-[50%] sm:w-full">
                      <p
                        className="text-[20px] leading-[26px] max-w-[640px]
                                  sm:text-[14px] sm:leading-[22px]
                                  xs:text-sm"
                        style={{
                          fontFamily: interFamily,
                          color: "#8D4660",
                        }}
                      >
                        Experience a cake ordering journey crafted for simplicity,
                        where your ideas take priority at every step
                      </p>
                    </div>
                      
                  </div>
                  <div className="w-full rounded-[20px] sm:p-0 xs:p-4 mt-14 sm:mt-6 md:mt-6 relative flex justify-center">
                  <Img
                    className="w-full h-[460px] sm:h-[200px] rounded-[20px]"
                    src="/images/playCake.png"
                    alt="cake"
                  />

                  <Img
                    className="absolute top-1/2 left-1/2 
                              -translate-x-1/2 -translate-y-1/2
                              w-[88px] h-[88px]
                              sm:w-[48px] sm:h-[48px]
                              xs:w-[48px] xs:h-[48px]"
                    src="/images/playButton.svg"
                    alt="play"
                  />
                </div>
                </div>       
              </div>
            </div>
          </section>
          <div className="bg-[#FFFFFF] flex sm:flex-col flex-row items-center justify-evenly w-full relative overflow-hidden">
            <div className="bg-[#FFFFF] flex md:flex-1 flex-col w-full items-start justify-center px-24 md:pl-4 py-12 md:px-10 sm:px-4 sm:py-10 xs:py-0 md:w-full">
              
              <div className="w-full bg-white rounded-lg p-8 sm:p-6">
                <div className="mb-6">
                  <h2 className="text-2xl sm:text-xl font-bold text-gray-800 mb-2">
                    <span className={`text-[#771237] ${headingClass} text-[32px] leading-[56px] font-semibold`}>Get Inspired</span>
                  </h2>
                  <p className={`text-[16px] text-[#8D4660] sm:text-xs ${interClass} leading-[24px]`}>
                    Explore our heart-shaped cake designs. Each one can be personalized to your table.
                  </p>
                </div>

                <div className="grid sm:hidden grid-cols-3 gap-4 mb-6">
                  {images.map((img, index) => (
                    <div
                      key={index}
                      className="relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
                    >
                      <div className="aspect-square flex items-center justify-center">
                        <img
                          src={img.src}
                          alt={img.alt}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <div className="hidden sm:block mb-6 relative overflow-hidden rounded-lg">
                  <div className="w-full h-[300px] relative">
                    {images.map((img, index) => (
                      <img
                        key={index}
                        src={img.src}
                        alt={img.alt}
                        className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-700 ${
                          index === current ? "opacity-100" : "opacity-0"
                        }`}
                      />
                    ))}
                  </div>

                  <div className="flex justify-center mt-3 gap-2">
                    {images.map((_, index) => (
                      <div
                        key={index}
                        className={`h-2 w-2 rounded-full ${
                          index === current ? "bg-[#8B1538]" : "bg-gray-300"
                        }`}
                      />
                    ))}
                  </div>
                </div>

                <div className="flex gap-8 sm:flex-col justify-center items-center sm:gap-4">
                  <button className={`px-6 mt-4 text-[16px] py-2.5 border-2 border-gray-800 text-gray-800 rounded-full font-medium ${headingClass} transition-colors duration-300 sm:w-full`}>
                    {t("browseCakes")}
                  </button>
                  <button className={`px-6 mt-4 text-[16px] py-2.5 bg-[#8B1538] text-[white] rounded-full font-medium ${headingClass} hover:bg-[#6B0F2A] transition-colors duration-300 sm:w-full`}>
                    {t("customizedCakes")}
                  </button>
                </div>
              </div>

            </div>
          </div>
          <section id="section-3" className="md:overflow-hidden">
              <div
                className="flex flex-col sm:gap-4 gap-2 justify-center items-center w-full  mx-auto my-6  px-24 md:px-10 sm:px-4"
              >
                <div className="flex flex-col mx-auto w-full relative p-4">
                  <Text className={`text-[#771237] text-center sm:text-left text-3xl ${headingClass} font-semibold`}>
                    {t("whyChooseUs")}
                  </Text>
                  <Text className={`  text-[#8D4660] text-center ${interClass} sm:text-left text-base mt-2 `}>
                    {t("discoverWhatMakesOurHandmadeCakesSpecialUs")}
                  </Text>
                </div>
              </div>
              <div
                className="my-6 mx-auto  px-24 md:px-10 sm:px-4"
              >
                <FeatureCards />
              </div>
            </section>
          <Footer className="flex font-nunitoregular items-center justify-center mt-[65px] md:px-5 w-full" />
        </div >
      </div >
    </>
  );
};

export default DesignMyOwnCake;